import {getACMHeaders} from './acm-helpers';

export const getBlob = (url, mimeType, token, projectScope) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const onError = () => {
      reject(xhr);
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(new Blob([xhr.response], {type: mimeType}));
      } else {
        onError();
      }
    };

    xhr.onerror = onError;
    xhr.ontimeout = onError;

    xhr.open('GET', url, true);

    // !!important!!
    // The responseType is being set *after* the call to xhr.open because of IE11
    // See https://stackoverflow.com/a/34647690
    xhr.responseType = 'blob';

    if (token) {
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    }
    const acmHeaders = getACMHeaders(projectScope);
    Object.keys(acmHeaders).forEach(key => {
      xhr.setRequestHeader(key, acmHeaders[key]);
    });

    xhr.send();
  });
